import React, { useEffect, useRef, useState } from "react";
import OtpInput from "react-otp-input";

const InputCode = ({ onComplete, otp }) => {
  const otpRef = useRef(null);
  const [prevOtp, setPrevOtp] = useState();
  const updateOtp = (otp) => {
    onComplete(otp);
    setPrevOtp(otp);
  };

  useEffect(() => {
    otpRef.current.focusInput(0);
  }, []);

  useEffect(() => {
    if (otp?.length < prevOtp?.length) otpRef.current.focusInput(otp.length);
  }, [otp]);

  return (
    <div>
      <OtpInput
        ref={otpRef}
        value={otp}
        onChange={(e) => updateOtp(e)}
        numInputs={6}
        shouldAutoFocus={true}
        inputStyle="otp-input"
        className="mr-16"
        isInputNum={true}
      />
    </div>
  );
};

export default InputCode;
